import React from 'react'
import PropTypes from 'prop-types'
import Wrapper from './FormErrorMessage.style'

const FormErrorMessage = ({ errorMessage }) => {
  return <Wrapper className="error">{errorMessage}</Wrapper>
}

FormErrorMessage.propTypes = {
  errorMessage: PropTypes.string,
}

FormErrorMessage.defaultProps = {
  errorMessage: '',
}

export default FormErrorMessage
